module.exports = __webpack_public_path__ + "static/media/anchor_white_24dp.41782915.svg";